import { H1, H2, P1 } from '../../../styles/FontStyles';
import { colors } from '../../../styles/GlobalStyles';
import {
  Main,
  Section1Image1,
  Section1Image2,
  Section1Wrapper,
} from '../Home.styled';

import image1 from '../../../assets/images/section1Image1.png';
import { Div } from '../../../styles/Styles';
import { AboutPill } from '../../../styles/svg';

export const Section1 = () => {
  return (
    <Section1Wrapper>
      <div id='section1'>
        <Div $m='200px 0'>
          <H2 mb='12' center color={colors.white}>
            Welcome to
          </H2>
          <H1 center color={colors.white}>
            Revolution of Travel
          </H1>
        </Div>
        {/* <Section1Image1 src={image1} alt='all in one' /> */}
      </div>
      <Main id='section2'>
        <Div
          $flex
          $justifyCenter
          $center
          $columnSM
          $reverseSM
          $gap='100px'
          $gapSM='20px'
        >
          <Div $width='50%' $widthSM='100%'>
            <Section1Image2 src={image1} alt='who we are' />
          </Div>
          <Div $width='50%' $widthSM='100%' $flex $column>
            <H2 centerSM mb='12' mt='24' color={colors.primary}>
              Travelution has arrived
            </H2>
            <P1 centerSM color={colors.white}>
              The travel industry is on the verge of transformation and we are
              at the forefront of this revolution. Traditional travel planning
              can take hours or even days. Travelution’s automated system
              reduces this to mere minutes, saving users valuable time. Say
              goodbye to juggling multiple apps—Travelution streamlines
              everything into a single, intelligent platform designed for
              effortless, personalized travel.
            </P1>
          </Div>
        </Div>
      </Main>
    </Section1Wrapper>
  );
};
